<script setup>
import SubSectionTitle from './Section/SubSectionTitle.vue'
import SubSectionTitleContainer from './Section/SubSectionTitleContainer.vue'

defineProps({
  title: String,
  as: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <div class="space-y-4">
    <SubSectionTitleContainer>
      <template #title>
        <template v-if="$slots.title">
          <slot name="title" />
        </template>
        <template v-else>
          <SubSectionTitle :title="title" :as="as">
            {{ title }}
          </SubSectionTitle>
        </template>
      </template>

      <template #actions>
        <slot name="actions" />
      </template>
    </SubSectionTitleContainer>

    <section>
      <slot />
    </section>
  </div>
</template>
